/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  IntegrateBusinessReportResponse,
  IntegrateCustomReportRequest,
  IntegrateDashboardGroupMoveRequest,
  IntegrateDashboardGroupPatchRequest,
  IntegrateDashboardPatchRequest,
  IntegrateDashboardPatchResponse,
  IntegrateFavoriteDashboardPatchRequest,
  IntegrateFeaturedReportResponse,
  PostV6DashboardsFavoriteParams,
  PostV6DashboardsGroupParams,
  ResultResponse,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 설정 > 리포트 > 비즈니스 리포트 추출
 */
export const getV6DashboardsBusinessReportByServiceId = (
  serviceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  serviceId = unref(serviceId);

  return customAxiosInstance<IntegrateBusinessReportResponse>(
    { url: `/api/v6/dashboards/business-report/${serviceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV6DashboardsBusinessReportByServiceIdQueryKey = (
  serviceId?: MaybeRef<string>,
) => {
  return ['api', 'v6', 'dashboards', 'business-report', serviceId] as const;
};

export const getGetV6DashboardsBusinessReportByServiceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>,
  TError = ErrorType<unknown>,
>(
  serviceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6DashboardsBusinessReportByServiceIdQueryKey(serviceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>
  > = ({ signal }) => getV6DashboardsBusinessReportByServiceId(serviceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(serviceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>,
    TError,
    TData
  >;
};

export type GetV6DashboardsBusinessReportByServiceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>
>;
export type GetV6DashboardsBusinessReportByServiceIdQueryError = ErrorType<unknown>;

/**
 * @summary 설정 > 리포트 > 비즈니스 리포트 추출
 */

export function useGetV6DashboardsBusinessReportByServiceId<
  TData = Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>,
  TError = ErrorType<unknown>,
>(
  serviceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV6DashboardsBusinessReportByServiceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6DashboardsBusinessReportByServiceIdQueryOptions(serviceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 리포트 대시보드 설정
 */
export const patchV6DashboardsCustomReport = (
  integrateCustomReportRequest: MaybeRef<IntegrateCustomReportRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  integrateCustomReportRequest = unref(integrateCustomReportRequest);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v6/dashboards/custom-report`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateCustomReportRequest,
    },
    options,
  );
};

export const getPatchV6DashboardsCustomReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>,
    TError,
    { data: BodyType<IntegrateCustomReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>,
  TError,
  { data: BodyType<IntegrateCustomReportRequest> },
  TContext
> => {
  const mutationKey = ['patchV6DashboardsCustomReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>,
    { data: BodyType<IntegrateCustomReportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV6DashboardsCustomReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV6DashboardsCustomReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>
>;
export type PatchV6DashboardsCustomReportMutationBody = BodyType<IntegrateCustomReportRequest>;
export type PatchV6DashboardsCustomReportMutationError = ErrorType<unknown>;

/**
 * @summary 리포트 대시보드 설정
 */
export const usePatchV6DashboardsCustomReport = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>,
      TError,
      { data: BodyType<IntegrateCustomReportRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV6DashboardsCustomReport>>,
  TError,
  { data: BodyType<IntegrateCustomReportRequest> },
  TContext
> => {
  const mutationOptions = getPatchV6DashboardsCustomReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 추가/수정/삭제
 */
export const postV6DashboardsDashboard = (
  integrateDashboardPatchRequest: MaybeRef<IntegrateDashboardPatchRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateDashboardPatchRequest = unref(integrateDashboardPatchRequest);

  return customAxiosInstance<IntegrateDashboardPatchResponse>(
    {
      url: `/api/v6/dashboards/dashboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardPatchRequest,
      signal,
    },
    options,
  );
};

export const getPostV6DashboardsDashboardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6DashboardsDashboard>>,
    TError,
    { data: BodyType<IntegrateDashboardPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6DashboardsDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardPatchRequest> },
  TContext
> => {
  const mutationKey = ['postV6DashboardsDashboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6DashboardsDashboard>>,
    { data: BodyType<IntegrateDashboardPatchRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV6DashboardsDashboard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6DashboardsDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6DashboardsDashboard>>
>;
export type PostV6DashboardsDashboardMutationBody = BodyType<IntegrateDashboardPatchRequest>;
export type PostV6DashboardsDashboardMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 추가/수정/삭제
 */
export const usePostV6DashboardsDashboard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6DashboardsDashboard>>,
      TError,
      { data: BodyType<IntegrateDashboardPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6DashboardsDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardPatchRequest> },
  TContext
> => {
  const mutationOptions = getPostV6DashboardsDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 그룹 이동
 */
export const postV6DashboardsDashboardGroups = (
  integrateDashboardGroupMoveRequest: MaybeRef<IntegrateDashboardGroupMoveRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateDashboardGroupMoveRequest = unref(integrateDashboardGroupMoveRequest);

  return customAxiosInstance<IntegrateDashboardPatchResponse>(
    {
      url: `/api/v6/dashboards/dashboard/groups`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardGroupMoveRequest,
      signal,
    },
    options,
  );
};

export const getPostV6DashboardsDashboardGroupsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>,
    TError,
    { data: BodyType<IntegrateDashboardGroupMoveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>,
  TError,
  { data: BodyType<IntegrateDashboardGroupMoveRequest> },
  TContext
> => {
  const mutationKey = ['postV6DashboardsDashboardGroups'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>,
    { data: BodyType<IntegrateDashboardGroupMoveRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV6DashboardsDashboardGroups(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6DashboardsDashboardGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>
>;
export type PostV6DashboardsDashboardGroupsMutationBody =
  BodyType<IntegrateDashboardGroupMoveRequest>;
export type PostV6DashboardsDashboardGroupsMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 그룹 이동
 */
export const usePostV6DashboardsDashboardGroups = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>,
      TError,
      { data: BodyType<IntegrateDashboardGroupMoveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6DashboardsDashboardGroups>>,
  TError,
  { data: BodyType<IntegrateDashboardGroupMoveRequest> },
  TContext
> => {
  const mutationOptions = getPostV6DashboardsDashboardGroupsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 즐겨찾기 추가/삭제
 */
export const postV6DashboardsFavorite = (
  integrateFavoriteDashboardPatchRequest: MaybeRef<IntegrateFavoriteDashboardPatchRequest>,
  params?: MaybeRef<PostV6DashboardsFavoriteParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateFavoriteDashboardPatchRequest = unref(integrateFavoriteDashboardPatchRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v6/dashboards/favorite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateFavoriteDashboardPatchRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV6DashboardsFavoriteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6DashboardsFavorite>>,
    TError,
    {
      data: BodyType<IntegrateFavoriteDashboardPatchRequest>;
      params?: PostV6DashboardsFavoriteParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6DashboardsFavorite>>,
  TError,
  {
    data: BodyType<IntegrateFavoriteDashboardPatchRequest>;
    params?: PostV6DashboardsFavoriteParams;
  },
  TContext
> => {
  const mutationKey = ['postV6DashboardsFavorite'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6DashboardsFavorite>>,
    {
      data: BodyType<IntegrateFavoriteDashboardPatchRequest>;
      params?: PostV6DashboardsFavoriteParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV6DashboardsFavorite(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6DashboardsFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6DashboardsFavorite>>
>;
export type PostV6DashboardsFavoriteMutationBody = BodyType<IntegrateFavoriteDashboardPatchRequest>;
export type PostV6DashboardsFavoriteMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 즐겨찾기 추가/삭제
 */
export const usePostV6DashboardsFavorite = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6DashboardsFavorite>>,
      TError,
      {
        data: BodyType<IntegrateFavoriteDashboardPatchRequest>;
        params?: PostV6DashboardsFavoriteParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6DashboardsFavorite>>,
  TError,
  {
    data: BodyType<IntegrateFavoriteDashboardPatchRequest>;
    params?: PostV6DashboardsFavoriteParams;
  },
  TContext
> => {
  const mutationOptions = getPostV6DashboardsFavoriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 설정 > 리포트 > 대시보드 추출 추가 > 리포트 템플릿 조회
 */
export const getV6DashboardsFeaturedReport = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<IntegrateFeaturedReportResponse>(
    { url: `/api/v6/dashboards/featured-report`, method: 'GET', signal },
    options,
  );
};

export const getGetV6DashboardsFeaturedReportQueryKey = () => {
  return ['api', 'v6', 'dashboards', 'featured-report'] as const;
};

export const getGetV6DashboardsFeaturedReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6DashboardsFeaturedReportQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>> = ({
    signal,
  }) => getV6DashboardsFeaturedReport(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>,
    TError,
    TData
  >;
};

export type GetV6DashboardsFeaturedReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>
>;
export type GetV6DashboardsFeaturedReportQueryError = ErrorType<unknown>;

/**
 * @summary 설정 > 리포트 > 대시보드 추출 추가 > 리포트 템플릿 조회
 */

export function useGetV6DashboardsFeaturedReport<
  TData = Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV6DashboardsFeaturedReport>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6DashboardsFeaturedReportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 그룹 추가/편집/삭제
 */
export const postV6DashboardsGroup = (
  integrateDashboardGroupPatchRequest: MaybeRef<IntegrateDashboardGroupPatchRequest>,
  params?: MaybeRef<PostV6DashboardsGroupParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateDashboardGroupPatchRequest = unref(integrateDashboardGroupPatchRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v6/dashboards/group`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardGroupPatchRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV6DashboardsGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6DashboardsGroup>>,
    TError,
    { data: BodyType<IntegrateDashboardGroupPatchRequest>; params?: PostV6DashboardsGroupParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6DashboardsGroup>>,
  TError,
  { data: BodyType<IntegrateDashboardGroupPatchRequest>; params?: PostV6DashboardsGroupParams },
  TContext
> => {
  const mutationKey = ['postV6DashboardsGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6DashboardsGroup>>,
    { data: BodyType<IntegrateDashboardGroupPatchRequest>; params?: PostV6DashboardsGroupParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV6DashboardsGroup(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6DashboardsGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6DashboardsGroup>>
>;
export type PostV6DashboardsGroupMutationBody = BodyType<IntegrateDashboardGroupPatchRequest>;
export type PostV6DashboardsGroupMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 그룹 추가/편집/삭제
 */
export const usePostV6DashboardsGroup = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6DashboardsGroup>>,
      TError,
      { data: BodyType<IntegrateDashboardGroupPatchRequest>; params?: PostV6DashboardsGroupParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6DashboardsGroup>>,
  TError,
  { data: BodyType<IntegrateDashboardGroupPatchRequest>; params?: PostV6DashboardsGroupParams },
  TContext
> => {
  const mutationOptions = getPostV6DashboardsGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
